import { lazy } from "react";

export const Delivery = lazy(() => import("./Delivery"));
export const TakeAway = lazy(() => import("./TakeAway"));
export const DineIn = lazy(() => import("./DineIn"));
export const StealDeals = lazy(() => import("./stealDeals/StealDeals"));
export const Events = lazy(() => import("./events/Events"));
export const EventDetailsPage = lazy(() => import("./events/EventDetailsPage"));
